import { Ref } from "react";
import { WebApiRequest, HTTP_POST, HTTP_GET } from "tools/webservice";
import { CubiCasaGoToScanStatus } from "interfaces/Mueller.Business.Models";

export const submitFixRequest = (controlNumber: number, payload: any, successCallback: any, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/cubi-casa/${controlNumber}/fix-request`,
  payload,
  successCallback,
  errorCallback,
  mountedRef
});

export const getGoToScanStatus = (controlNumber: number, successCallback: (status: CubiCasaGoToScanStatus) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/cubi-casa/${controlNumber}/go-to-scan`,
  successCallback,
  errorCallback,
  mountedRef
});

export const createGoToScan = (controlNumber: number, successCallback: (status: CubiCasaGoToScanStatus) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/cubi-casa/${controlNumber}/go-to-scan`,
  successCallback,
  errorCallback,
  mountedRef
});